module.exports = __webpack_public_path__ + "static/img/ANTICA-OAK.1df3af0.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/ANTICA-OAK.png
// module id = nonc
// module chunks = 0